import { Injectable, computed } from "@angular/core";
import { signalStore, withState, patchState } from "@ngrx/signals";
import { UserNote, UserNoteServiceNEW } from "../service/userNote.service-NEW";

type NotesState = {
    userNoteCache: {
        contentId: string;
        notes: UserNote[],
    }[];
};

const initialState: NotesState = {
    userNoteCache: [],
};

@Injectable({
    providedIn: 'root'
})
export class NotesStore extends signalStore(
    { protectedState: false, providedIn: 'root' },
    withState(initialState)
) {
    constructor(
        private userNoteService: UserNoteServiceNEW
    ) {
        super();
    }

    async loadUserNotes(contentId: string) {
        try {
            const notes = await this.userNoteService.getUserNotes(contentId);
            patchState(this, {
                userNoteCache: [
                    ...this.userNoteCache().filter(entry => entry.contentId !== contentId), // Remove existing entry if exists
                    { contentId, notes }, // Add new entry
                ],
            });
        } catch (error) {
            console.error('Error loading user notes:', error);
        }
    }

    async deleteNote(userNoteId: string) {
        const success = await this.userNoteService.deleteUserNote(userNoteId);
        if (success) {
            patchState(this, {
                userNoteCache: this.userNoteCache().map(content => ({ ...content, notes: content.notes.filter(n => n.id != userNoteId) }))
            });
        }
    }


    async createOrSaveNote(contentId: string, contentNoteId: string, noteContent: string) {

        let userNoteId = undefined;
        //Find the corresponding user note. If found, this is an update

        for (const entry of this.userNoteCache()) {
            const userNote = entry.notes.find(n => n.noteId === contentNoteId);
            if (userNote) {
                userNoteId = userNote.id;
                break;
            }
        }

        try {
            if (userNoteId) {
                // **Update existing note**
                const updatedNote = await this.userNoteService.updateUserNote({ userNoteId: userNoteId, content: noteContent });
                patchState(this, {
                    // @ts-ignore
                    userNoteCache: this.userNoteCache().map(entry =>
                        entry.contentId === contentId
                            ? {
                                ...entry,
                                notes: entry.notes.map(n =>
                                    n.noteId === contentNoteId ? { ...n, content: noteContent } : n
                                ),
                            }
                            : entry
                    ),
                });
            } else {
                // **Create new note**
                const newNote = await this.userNoteService.createUserNote({ contentId: contentId, contentNoteId: contentNoteId, content: noteContent });
                patchState(this, {
                    userNoteCache: this.userNoteCache().map(contentSpecificUserNotes => ({
                        ...contentSpecificUserNotes,
                        notes: [...contentSpecificUserNotes.notes, newNote]
                    }))
                });

            }
        } catch (error) {
            console.error('Error creating or updating note:', error);
        }
    }

    noteById = (contentNoteId: string | null) => computed(() => {
        const userNotes = this.userNoteCache();
        for (const entry of userNotes) {
            const foundNote = entry.notes.find(note => note.noteId === contentNoteId);
            if (foundNote) {
                return foundNote;
            }
        }
        return null; // Note not found
    });
}